import React from 'react';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';

/*
 Takes a prop of data, which is an array of objects.
 Example:
[
  {"Asset_Id":35040430,"ShareClass_Id":60052417,"Holdings_Date":{"value":"2023-06-30"},"Holding_Id":20436682,"Holding_Name":"Tencent Holdings Ltd ORD","Holding_Weight":9.6586,"Holding_Rank":1,"Holding_Type_Value":"Common Shares"}
]

The array should already be sorted by Item_Rank
 */

const PortfolioHoldings = ({ data }) => {
  const header = "Top 10 Holdings";
  return (
    <Container>
      <h3>{header}</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Holding Name</th>
            <th>Holding Weight</th>
          </tr>
        </thead>
        <tbody>
          {data.map(obj => (
            <tr key={obj.Holding_Id}>
              <td className="tableitem">{obj.Holding_Name}</td>
              <td className="tableitem" style={{ textAlign: 'right' }}>{obj.Holding_Weight.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};
export default PortfolioHoldings;